<template>
	<div class="modal-content text-gray">
		<div class="modal-header">
			<div class="modal-title font-size-lg-12 font-size-sm-10" id="exampleModalCenterTitle">List Detail Riwayat Produk {{tanggal | tanggal }}</div>
			<button type="button" class="close ml-0" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="container-fluid">
				<div class="row mt-3">
					<div class="col-12 col-md-12">
						<div class="col-12 pl-0 pr-0 d-flex">
							<div class="col-2 col-md-1 pl-0"><img :src="produk.image" class="img-fluid rounded-cus"></div>
							<div class="col-10 col-md-11 pl-0 mt-auto mb-auto">{{produk.name}}</div>
						</div>
						<div class="col-12 p-0" v-show="Object.values(detailRiwayat).length == 0 ">
							<div class="row" v-for=" index in 4" :key="index">
								<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
									<div class="col-12 p-0 pt-2 pb-3 background-white rounded cus-box-shadow font-size-10 font-size-sm-8">
										<vcl :width='400' :height='28'>
											<rect x="11" y="3" rx="3" ry="3" width="30" height="8" />
											<rect x="11" y="18" rx="3" ry="3" width="30" height="8" />
											<rect x="90" y="3" rx="2" ry="2" width="40" height="8" />
											<rect x="100" y="18" rx="2" ry="2" width="20" height="8" />
											<rect x="175" y="3" rx="2" ry="2" width="50" height="8" />
											<rect x="175" y="18" rx="2" ry="2" width="30" height="8" />
											<rect x="270" y="3" rx="2" ry="2" width="50" height="8" />
											<rect x="270" y="18" rx="2" ry="2" width="90" height="8" />
										</vcl>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 p-0" v-if="Object.values(detailRiwayat).length > 0">
							<div class="col-12 pl-0 pr-0 pt-2 pb-2 mt-2 border rounded-cus d-flex flex-wrap" v-for="(detail, index) in detailRiwayat" :key="index">
								<div class="col-5 col-md-2">
									<div>Status</div>
									<div><img :src="detail.stock_log_type == 'in' ? 'assets/icon/serial_in.png' : 'assets/icon/serial_out.png'" class="img-fluid mt-n1 pr-1"><span>{{detail.stock_log_type | convertStockType}}</span></div>
								</div>
								<div class="col-7 col-md-2 text-md-center">
									<div>Jumlah</div>
									<div class="pt-1">{{detail.stock_log_value}}</div>
								</div>
								<div class="col-5 col-md-3 pt-2 pt-md-0">
									<div>Stok Terakhir</div>
									<div class="pt-1"><img src="assets/icon/stok_serial.png" class="img-fluid mt-n1 pr-1"><span>{{detail.stock_log_last_store}}</span></div>
								</div>
								<div class="col-7 col-md-5 pt-2 pt-md-0">
									<div class="d-flex">
										<i class="far fa-calendar-alt mt-auto mb-auto color-blue"></i>
										<div class="ml-2">{{detail.stock_log_datetime | tanggaljam}}</div>
									</div>
									<div class="pt-1">{{detail.stock_log_note}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	name: 'detailRiwayatStock',
	props: {
		tanggal: {
			type: String
		},
		produk: {
			type: Object
		},
	},
	computed: {
		...mapState('stockList', ['detailRiwayat']),
		...mapGetters('auth', ['isAuth']),
	},
}
</script>